function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { classnames } from '@bydesign-ui/utils';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { useChildrenEnterLeave } from '../../../hooks/animation';
import { Inbox, Search } from '../../../common/icons';
import { Input } from '../../input';
import { Item } from './Item';
export function Panel(props) {
  var title = props.title,
      showSearch = props.showSearch,
      search = props.search,
      _props$data = props.data,
      data = _props$data === void 0 ? [] : _props$data,
      onChange = props.onChange,
      direction = props.direction,
      disableAnimation = props.disableAnimation;
  var localeEmpty = useLocale('transfer.empty');
  var localePlaceholder = useLocale('transfer.placeholder');

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var onValueChange = useCallback(function (value) {
    setValue(value);
    search(value, direction);
  }, []);
  var onItemChange = useCallback(function (id, checked) {
    onChange(direction, id, checked);
  }, []);
  var cls = classnames(usePrefixCls('transfer-panel'), showSearch ? 'has-search' : '');
  var titleCls = classnames(usePrefixCls('transfer-panel-title'));
  var bodyCls = classnames(usePrefixCls('transfer-panel-body'), data.length === 0 ? 'empty' : '');
  var inputCls = classnames(usePrefixCls('transfer-panel-input'));
  var ListCls = classnames(usePrefixCls('transfer-panel-body-list'));
  var placeholderCls = classnames(usePrefixCls('transfer-panel-placeholder'));
  var placeholderTextCls = classnames(usePrefixCls('transfer-panel-placeholder-text'));
  var placeholderIconCls = classnames(usePrefixCls('transfer-panel-placeholder-icon'));
  var children = data.filter(function (i) {
    return !i.hidden;
  }).map(function (i, index) {
    var id = i.id ? i.id : index;
    return React.createElement(Item, {
      key: id,
      id: id,
      checked: i.checked,
      value: i.value,
      disabled: i.disabled,
      onChange: onItemChange
    });
  });

  var _useChildrenEnterLeav = useChildrenEnterLeave(children, {
    duration: 200,
    childRefKey: 'domRef',
    enterTick: function enterTick() {
      return void 0;
    },
    ignoreInitialRender: true,
    disabled: !data.length || disableAnimation,
    enterChildProps: {
      'data-motion-fade': 'in'
    },
    leaveChildProps: {
      'data-motion-fade': 'out'
    }
  }),
      _useChildrenEnterLeav2 = _slicedToArray(_useChildrenEnterLeav, 2),
      animatedChildren = _useChildrenEnterLeav2[0],
      startAnimation = _useChildrenEnterLeav2[1];

  useEffect(startAnimation);
  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: titleCls
  }, title), showSearch && React.createElement("div", {
    className: inputCls
  }, React.createElement(Input, {
    value: value,
    onValueChange: onValueChange,
    prefix: React.createElement(Search, null),
    placeholder: localePlaceholder
  })), React.createElement("div", {
    className: bodyCls
  }, data.length > 0 ? React.createElement("ul", {
    className: ListCls
  }, animatedChildren) : React.createElement("div", {
    className: placeholderCls
  }, React.createElement("div", null, React.createElement(Inbox, {
    className: placeholderIconCls,
    size: "37px"
  }), React.createElement("p", {
    className: placeholderTextCls
  }, localeEmpty)))));
}